"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 *  DBAccess provides an interface to IndexedDB, an in browser offline storage technology.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API for more details
 *
 *  This module is intended to be used as a singleton.  If you need to access more than one in browser
 *  database (not object store), don't use this module.
 */
var MODE = /*#__PURE__*/function (MODE) {
  MODE["readwrite"] = "readwrite";
  MODE["read"] = "readonly";
  return MODE;
}(MODE || {});
var indexedDb = window.indexedDB;
function getErrorFromEventTarget(event) {
  if (event && event.target) {
    var error = event.target.error;
    if (error && error instanceof Error) {
      return error;
    }
  }
  return;
}
var DBAccess = exports["default"] = /*#__PURE__*/function () {
  function DBAccess(logger) {
    _classCallCheck(this, DBAccess);
    _defineProperty(this, "isOpen", false);
    this.logger = logger;
  }

  /**
   * Opens the database.  If successful, the db var will be init'd
   * @param dbName - the name of the db we're trying to open
   * @param version - the version of the db we're trying to open
   * @param storeName - the object store to create if the db doesn't exist or the version is outdated
   * @param keypath - the path to the access key in the default object store
   * @param successCallback - A callback to execute on success
   * @param failureCallback - A callback to execute on failure
   */
  return _createClass(DBAccess, [{
    key: "openDb",
    value: function openDb(dbName, version, storeName, keyPath, successCallback, failureCallback) {
      var _this = this;
      if (!indexedDb || this.db) {
        return;
      }
      var openDbRequest = indexedDb.open(dbName, version);
      if (!openDbRequest) {
        // Safari returns null for indexedDb.open in private mode
        return;
      }
      openDbRequest.onupgradeneeded = function (e) {
        _this._openDbUpgradeNeeded(openDbRequest.result, e.oldVersion, version, storeName, keyPath, successCallback);
      };
      openDbRequest.onsuccess = function () {
        _this._openDbSuccess(openDbRequest.result, successCallback, storeName);
      };
      openDbRequest.onerror = function (event) {
        _this._openDbError(event, failureCallback);
      };
    }

    /**
     * Add an object to the specified store
     * If you haven't opened the DB yet, this call will fail
     *
     * @param storeName - the name of the store you want to access
     * @param object - the object you want to store.  Should have a field that matches the keypath for the store.
     * @param successCallback - the function to execute if the get call is successful
     * @param failureCallback - the function to execute if the get call fails, or any other
     *                          error occurs
     */
  }, {
    key: "addObject",
    value: function addObject(storeName, object, successCallback, failureCallback) {
      var _this2 = this;
      var adjustedErrorCallback = function adjustedErrorCallback(event) {
        _this2._logMessage('Failed to add object in dbaccess ', event);
        failureCallback(true);
      };
      var store = this._getStore(storeName, MODE.readwrite, false, successCallback, adjustedErrorCallback, adjustedErrorCallback);
      if (!store) {
        return failureCallback();
      }
      var addRequest;
      try {
        addRequest = store.add(object);
      } catch (e) {
        adjustedErrorCallback(e);
      }
      if (addRequest) {
        addRequest.onerror = adjustedErrorCallback;
      } else {
        return failureCallback(true);
      }
    }
  }, {
    key: "getKeyExists",
    value: function getKeyExists(storeName, key, successCallback, failureCallback) {
      var _this3 = this;
      var store = this._getStore(storeName, MODE.read);
      if (!store) {
        return failureCallback();
      }
      var getRequest;
      try {
        getRequest = store.count(key);
      } catch (e) {
        this._logMessage('Failed to get object in dbaccess', e);
        return failureCallback(true);
      }
      if (getRequest) {
        getRequest.onsuccess = function () {
          var value = getRequest.result;
          successCallback(!!value);
        };
        getRequest.onerror = function (event) {
          _this3._logMessage('Failed to get object in dbaccess', event);
          failureCallback(true);
        };
      } else {
        return failureCallback(false);
      }
    }

    /**
     * Get an object from the specified store for the given key
     * If you haven't opened the DB yet, this call will fail
     *
     * @param storeName - the name of the store you want to access
     * @param key - the key corresponding to the value you want to retrieve
     * @param successCallback - the function to execute if the get call is successful
     * @param failureCallback - the function to execute if the get call fails, or any other
     *                          error occurs
     */
  }, {
    key: "getObject",
    value: function getObject(storeName, key, successCallback, failureCallback) {
      var _this4 = this;
      var store = this._getStore(storeName, MODE.read);
      if (!store) {
        return failureCallback();
      }
      var getRequest;
      try {
        getRequest = store.get(key);
      } catch (e) {
        this._logMessage('Failed to get object in dbaccess', e);
        return failureCallback(true);
      }
      if (getRequest) {
        getRequest.onsuccess = function () {
          var value = getRequest.result;
          if (value) {
            successCallback(value);
          } else {
            failureCallback();
          }
        };
        getRequest.onerror = function (event) {
          _this4._logMessage('Failed to get object in dbaccess', event);
          failureCallback(true);
        };
      } else {
        return failureCallback(false);
      }
    }

    /**
     * Delete an object from the specified store with the given key
     *
     * @param storeName - the name of the store you want to access
     * @param key - the key for the object you want to delete
     */
  }, {
    key: "deleteObject",
    value: function deleteObject(storeName, key) {
      var _this5 = this;
      var store = this._getStore(storeName, MODE.readwrite);
      if (store) {
        var getRequest = store.get(key);
        getRequest.onsuccess = function () {
          var object = getRequest.result;
          if (object) {
            var deleteRequest = store["delete"](key);
            deleteRequest.onsuccess = function () {};
            deleteRequest.onerror = function (event) {
              _this5._logMessage('Failed to delete object in dbaccess', event);
            };
          }
        };
      }
    }

    /**
     * Clear the store with storeName if it exists
     *
     * @param storeName - The store you want to clear
     */
  }, {
    key: "clearStore",
    value: function clearStore(storeName) {
      this._clearStore(storeName);
    }
    /**
     * Clear the store with storeName if it exists
     *
     * @param storeName - The store you want to clear
     * @param callback - the function to execute if the get call is successful
     * @param force - If true, attempt to clear the store even if the db says its closed
     */
  }, {
    key: "_clearStore",
    value: function _clearStore(storeName, callback) {
      var _this6 = this;
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var store = this._getStore(storeName, MODE.readwrite, force);
      if (store) {
        var clearRequest = store.clear();
        clearRequest.onsuccess = function (event) {
          if (callback) {
            callback(event);
          }
        };
        clearRequest.onerror = function (event) {
          _this6._logMessage('Failed to clear objects in dbaccess', event, force, force);
        };
      }
    }

    /**
     * When the database fails to open, null out the global db handle and execute the callback
     *
     * @param event - the event fired when the open call finished
     * @param callback - the callback to execute after the handle is nulled out
     */
  }, {
    key: "_openDbError",
    value: function _openDbError(event, callback) {
      this.db = undefined;
      this.isOpen = false;
      var error = getErrorFromEventTarget(event);
      if (error && error.name === 'InvalidStateError' && error.message && error.message.indexOf('did not allow mutations') > 0) {
        // Assume Firefox private browsing
        return;
      }
      this._logMessage('Could not open db in dbaccess!', event, false, true);
      if (callback) {
        callback();
      }
    }
    /**
     * When the database is opened successfully, set the global db handle and execute the callback
     *
     * @param db - the opened database
     * @param callback - the callback to execute after the handle is set
     * @param clearStoreName - If supplied, attempt to clear this object store after the db is open
     */
  }, {
    key: "_openDbSuccess",
    value: function _openDbSuccess(db, callback, clearStoreName) {
      var _this7 = this;
      this.db = db;
      if (clearStoreName && db.objectStoreNames.contains(clearStoreName)) {
        try {
          this._clearStore(clearStoreName, function () {
            _this7.isOpen = true;
            if (callback) {
              callback();
            }
          }, true);
        } catch (e) {
          this._logMessage('Failed to clear store ' + clearStoreName + ' in dbaccess _openDbSuccess', e, true, true);
        }
      } else {
        this.isOpen = true;
        if (callback) {
          callback();
        }
      }
    }

    /**
     * If the database doesn't exist or is out of date, this will create it and it's object store
     *
     * @param db - the database
     * @param newStoreName - the name of the store to update/create
     * @param newKeyPath - the keypath to use for the object store that's being updated/created
     * @param callback - the callback to execute when upgrade/creation is complete
     */
  }, {
    key: "_openDbUpgradeNeeded",
    value: function _openDbUpgradeNeeded(db, oldVersion, newVersion, newStoreName, newKeyPath, callback) {
      var _this8 = this;
      this.db = db;
      if (oldVersion !== newVersion && db.objectStoreNames.contains(newStoreName)) {
        db.deleteObjectStore(newStoreName);
      }
      var objectStore = db.createObjectStore(newStoreName, {
        keyPath: newKeyPath
      });
      objectStore.transaction.oncomplete = function () {
        _this8._openDbSuccess(db, callback);
      };
    }
    /**
     * Returns a handle to the store in the specified mode
     *
     * @param storeName - The store you want to access
     * @param mode - the MODE you want to open the store in
     * @param force - If true, try to get the store even if the db says it's closed
     * @param txCompleteHandler - Optional handler for transaction.oncomplete event
     * @param txErrorHandler - Optional handler for transaction.onerror event
     * @param txAbortHandler - Optional handler for transaction.onabort event
     * @return a handle to the store, or null if it couldn't be accessed
     */
  }, {
    key: "_getStore",
    value: function _getStore(storeName, mode, force, txCompleteHandler, txErrorHandler, txAbortHandler) {
      if (!this.db) {
        return null;
      }
      if (!this.isOpen && !force) {
        return null;
      }
      var tx = this.db.transaction(storeName, mode);
      if (!tx) return null;
      if (txCompleteHandler) {
        tx.oncomplete = txCompleteHandler;
      }
      if (txErrorHandler) {
        tx.onerror = txErrorHandler;
      }
      if (txAbortHandler) {
        tx.onabort = txAbortHandler;
      }
      return tx.objectStore(storeName);
    }
    /**
     * Log a message to the log controller
     *
     * @param message - A string describing an error that occurred
     * @param eventOrError - An event or error object that optionally contains additional error data
     * @param nonFatal - If true, this is a non-fatal error, don't null out the connection
     * @param isInfo - If true, log as info, otherwise as error
     */
  }, {
    key: "_logMessage",
    value: function _logMessage(message, eventOrError, nonFatal, isInfo) {
      if (!nonFatal) {
        this.db = undefined;
        this.isOpen = false;
      }
      if (eventOrError && 'message' in eventOrError) {
        message = message + ': ' + eventOrError.message;
      } else {
        var error = getErrorFromEventTarget(eventOrError);
        if (error) {
          if (error.name) {
            message = message + ': ' + error.name;
          }
          if (error.message) {
            message = message + ': ' + error.message;
          }
        }
      }
      var logData = {
        Error: !isInfo || !nonFatal,
        VideoPlaybackPlayer: true,
        Message: message
      };
      if (!isInfo) {
        console.log(message);
      }
      this.logger.logIssue('IndexedDBError', logData);
    }
  }]);
}();